<template>
  <v-container class="pt-4 pb-12 py-sm-12">
    <!-- HEADER DESKTOP -->
 <v-row class="mb-0">
      <v-col cols="12" class="pb-0">
        <div class="title-container">
          <div class="title-block">
    <div class="d-flex align-center">
      <span class="page-title">Cashback</span>

      <!-- DESKTOP -->
      <v-menu offset-y transition="slide-y-transition" class="d-none d-sm-flex">
        <template v-slot:activator="{ on, attrs }">
          <v-btn small color="primary" text v-bind="attrs" v-on="on" class="d-none d-sm-flex">
            <v-icon left>mdi-help-circle-outline</v-icon>Ajuda
          </v-btn>
        </template>
        <v-card min-width="320px">
          <v-card-title class="text-h6 font-weight-bold pb-2">
            <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-3 pb-3">
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💰 Tipo de Serviço</p><p class="text-caption grey--text">Lavagem ou Secagem — cada um pode ter um percentual diferente</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📊 Percentual</p><p class="text-caption grey--text">Valor em % que o cliente recebe de volta no saldo após cada uso</p></div>
            <v-divider class="my-2"></v-divider>
            <div>
              <p class="font-weight-bold text-caption mb-1">⚠️ Regras</p>
              <v-alert dense type="error" outlined class="text-caption ma-0 pa-2">
                Combos não geram cashback. Pagamentos com saldo também não.
              </v-alert>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>

      <!-- MOBILE -->
      <v-btn icon small color="primary" class="ml-2 d-flex d-sm-none" @click="dialogAjudaMobile = true">
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </div>
    <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
      { text: 'Homepage', disabled: false, to: '/home', exact: true },
      { text: 'Cashback', disabled: true }
    ]" />
</div>
        <div class="button-group">
  <v-btn color="primary" outlined @click="abrirDialogNovo">Cadastrar</v-btn>
</div>
        </div>
      </v-col>
    </v-row>

<!-- Resumo -->
    <v-row class="mb-4" style="margin-top: 8px !important;" v-if="configs.length">
      <v-col cols="12">
        <v-alert type="info" dense outlined>
          <span v-for="(c, i) in configs" :key="c.id">
            {{ c.tipoProduto === 'LAVAR' ? 'Lavagem' : 'Secagem' }} ganha
           <strong>{{ Number(c.percentual).toFixed(2).replace('.', ',') }}%</strong> de cashback
            <span v-if="i < configs.length - 1"> · </span>
          </span>
        </v-alert>
      </v-col>
    </v-row>

    <!-- Tabela -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="configs"
          :loading="loading"
          loading-text="Carregando..."
          no-data-text="Nenhum cashback configurado"
          class="app-table cashback-table"
          disable-sort
          hide-default-footer
        >
<template v-slot:header.actions="{ header }">
  <span class="d-block" style="padding-right: 90px;">{{ header.text }}</span>
</template>
<template v-slot:header.percentual="{ header }">
  <span class="d-block text-center">{{ header.text }}</span>
</template>

          <template v-slot:item.tipoProduto="{ item }">
            {{ item.tipoProduto === 'LAVAR' ? 'Lavagem' : 'Secagem' }}
          </template>

        <template v-slot:item.percentual="{ item }">
  <span class="d-block text-center">{{ Number(item.percentual).toFixed(2).replace('.', ',') }}%</span>
</template>

         <template v-slot:item.actions="{ item }">
   <v-btn
  small
  color="primary-200"
  class="mr-7 action-btn-fixed"
  @click="abrirDialogEditar(item)"
>
  <v-icon left>mdi-pencil-outline</v-icon>
  Editar
</v-btn>
<v-btn
  small
  class="action-btn-fixed"
  style="background-color: #f44336 !important; color: white !important;"
  @click="abrirConfirmacaoExcluir(item)"
>
  <v-icon left>mdi-delete-outline</v-icon>
  Excluir
</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Dialog Novo -->
 <v-dialog v-model="dialogNovo" max-width="400">
      <v-card>
        <v-card-title>{{ form.id ? 'Editar Cashback' : 'Novo Cashback' }}</v-card-title>
        <v-card-text>
<v-card-text class="cashback-form">
  <v-select
    v-model="form.tipoProduto"
    :items="tiposProduto"
    item-text="label"
    item-value="value"
    label="Tipo de Serviço"
    outlined
    dense
    hide-details
    class="mb-4"
    :disabled="!!form.id"
  />

  <v-text-field
    v-model="form.percentual"
    label="Percentual (%)"
    placeholder="0,00"
    outlined
    dense
    reverse
    suffix="%"
    @input="formatarPercentual"
    @keypress="somenteNumero"
    hide-details
  />
</v-card-text>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialogNovo = false">Cancelar</v-btn>
          <v-btn color="primary" @click="salvar">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Excluir -->
   <v-dialog v-model="dialogExcluir" max-width="360px">
      <v-card class="pa-4 text-center">
        <v-card-text class="pt-4">
          <v-icon size="48" color="error" class="mb-3">mdi-trash-can-outline</v-icon>
          <h3 class="text-h6 font-weight-bold mb-2">Excluir Cashback</h3>
          <p class="grey--text text--darken-1">
            Tem certeza que deseja excluir o cashback de
            <strong>{{ itemParaExcluir.tipoProduto === 'LAVAR' ? 'Lavagem' : 'Secagem' }}</strong>?
          </p>
        </v-card-text>
     <v-card-actions class="justify-center pb-4">
          <v-btn text @click="dialogExcluir = false">Cancelar</v-btn>
          <v-btn style="background-color: #FF3636 !important; color: white !important;" elevation="0" @click="excluir">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<v-dialog v-model="dialogAjudaMobile" scrollable content-class="popup-mobile-dialog">
    <v-card>
        <div class="popup-mobile-header">
            <span class="popup-mobile-header-title">
                <v-icon small class="mr-2">mdi-lightbulb-on</v-icon>Ajuda dos Campos
            </span>
            <v-btn icon small class="popup-mobile-close" @click="dialogAjudaMobile = false">
                <v-icon size="18">mdi-close</v-icon>
            </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text class="pt-3 pb-3">
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">💰 Tipo de Serviço</p><p class="text-caption grey--text">Lavagem ou Secagem — cada um pode ter um percentual diferente</p></div>
            <v-divider class="my-2"></v-divider>
            <div class="mb-3"><p class="font-weight-bold text-caption mb-1">📊 Percentual</p><p class="text-caption grey--text">Valor em % que o cliente recebe de volta no saldo após cada uso</p></div>
            <v-divider class="my-2"></v-divider>
            <div>
              <p class="font-weight-bold text-caption mb-1">⚠️ Regras</p>
              <v-alert dense type="error" outlined class="text-caption ma-0 pa-2">
                Combos não geram cashback. Pagamentos com saldo também não.
              </v-alert>
            </div>
        </v-card-text>
    </v-card>
</v-dialog>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import { eventHub } from "@/main";

export default {
  name: "CashbackList",

  data() {
    return {
      loading: false,
      configs: [],
      dialogNovo: false,
      dialogExcluir: false,
      dialogAjudaMobile: false,
      itemParaExcluir: {},
      form: {
        tipoProduto: null,
        percentual: null
      },
     headers: [
  { text: "Tipo de Serviço", value: "tipoProduto", width: "29%" },
  { text: "Percentual", value: "percentual", align: "center", width: "34%" },
  { text: "Ações", value: "actions", sortable: false, align: "end", width: "50%" }
],
      tiposProduto: [
        { label: "Lavagem", value: "LAVAR" },
        { label: "Secagem", value: "SECAR" }
      ]
    };
  },

  mounted() {
    this.loadData();
    eventHub.$on("CHANGE-OPERATION", () => this.loadData());
  },

  destroyed() {
    eventHub.$off("CHANGE-OPERATION");
  },

  methods: {
   async loadData() {
  this.loading = true;
  try {
    const operacaoId = localStorage.getItem("operation");
    if (!operacaoId) return;
    const res = await axios.get("/api/cashback-config", { params: { operacaoId } });
    this.configs = res.data;
  } catch (err) {
    const msg = (err && err.response && err.response.data && err.response.data.mensagem) || "Erro ao carregar cashback.";
    this.$dialog.notify.error(msg, { position: "top-right", timeout: 4000 });
  } finally {
    this.loading = false;
  }
},

somenteNumero(e) {
  if (!/[0-9]/.test(e.key)) {
    e.preventDefault();
  }
},

   abrirDialogNovo() {
      this.form = { id: null, tipoProduto: null, percentual: null };
      this.dialogNovo = true;
    },

    abrirDialogEditar(item) {
  this.form = {
    id: item.id,
    tipoProduto: item.tipoProduto,
    percentual: Number(item.percentual).toFixed(2).replace('.', ',')
  };
  this.dialogNovo = true;
},

formatarPercentual(v) {
  if (!v) { this.form.percentual = ''; return; }
  let limpo = v.replace(/\D/g, '');
  if (!limpo) { this.form.percentual = ''; return; }
  let valor = (parseInt(limpo) / 100).toFixed(2);
  this.form.percentual = valor.replace('.', ',');
},

    async salvar() {
      if (!this.form.tipoProduto || !this.form.percentual) {
        this.$dialog.notify.error("Preencha todos os campos.", { position: "top-right", timeout: 3000 });
        return;
      }

      const payload = {
        operacaoId: localStorage.getItem("operation"),
        tipoProduto: this.form.tipoProduto,
        percentual: parseFloat(String(this.form.percentual).replace(',', '.'))
      };

      try {
        if (this.form.id) {
         await axios.put(`/api/cashback-config/${this.form.id}`, payload);
          this.$dialog.notify.success("Cashback atualizado com sucesso.", { position: "top-right", timeout: 3000 });
        } else {
          await axios.post("/api/cashback-config", payload);
          this.$dialog.notify.success("Cashback cadastrado com sucesso.", { position: "top-right", timeout: 3000 });
        }
        this.dialogNovo = false;
        this.loadData();
      } catch (err) {
        const msg = (err && err.response && err.response.data && err.response.data.mensagem) || "Erro ao salvar cashback.";
        this.$dialog.notify.error(msg, { position: "top-right", timeout: 5000 });
      }
    },

    abrirConfirmacaoExcluir(item) {
      this.itemParaExcluir = item;
      this.dialogExcluir = true;
    },

  async excluir() {
  this.dialogExcluir = false;
  try {
    await axios.delete(`/api/cashback-config/${this.itemParaExcluir.id}`);
    this.$dialog.notify.success("Cashback excluído com sucesso.", { position: "top-right", timeout: 3000 });
    this.loadData();
  } catch (err) {
    const msg = (err && err.response && err.response.data && err.response.data.mensagem) || "Erro ao excluir cashback.";
    this.$dialog.notify.error(msg, { position: "top-right", timeout: 4000 });
  }
}
  }  
};

</script>

<style scoped>
.page-title { font-size: 24px; font-weight: 700; }
.v-btn { min-width: 130px; font-weight: 600; }
.ga-3 { gap: 24px; }

@media (max-width: 600px) {
  .title-block .v-btn.ml-2 {
    min-width: 36px !important;
    width: 36px !important;
    margin-left: 4px !important;
  }
  .title-container {
    flex-wrap: wrap;
  }

  .button-group {
    width: 100%;
    margin-top: 25px;
  }

  .button-group .v-btn {
    width: 100%;
    min-width: unset;
  }

  .app-table.cashback-table.v-data-table--mobile .v-data-table__wrapper table tbody tr:first-child {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  .app-table.cashback-table *>>>* .v-data-table__wrapper {
    padding-top: 0;
  }
}
@media (max-width: 600px) {
  .cashback-form {
    padding-top: 0 !important;
    padding-bottom: 8px !important;
    margin-top: -16px !important;
  }
}
.action-btn-fixed {
  width: 100px;
}

@media (max-width: 768px) {
  .app-table.cashback-table.v-data-table--mobile table {
    table-layout: auto !important;
    width: 100% !important;
  }

  /* borda/espaçamento entre linhas do modo mobile do .app-table agora é global (assets/scss/main.scss) */

  .app-table.cashback-table.v-data-table--mobile .v-data-table__mobile-row {
    width: 100% !important;
  }
  .app-table.cashback-table.v-data-table--mobile .v-data-table__mobile-row {
    padding-left: 0 !important;
  }

  .app-table.cashback-table.v-data-table--mobile .v-data-table__mobile-row__header {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }
.app-table.cashback-table.v-data-table--mobile .v-data-table__mobile-row {
  padding: 4px 0 !important;
  min-height: auto !important;
}
  .app-table.cashback-table.v-data-table--mobile .v-data-table__mobile-row__header {
    font-size: 13px !important;
    color: #333 !important;
    font-weight: 700 !important;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .app-table.cashback-table.v-data-table--mobile .v-data-table__mobile-row__cell {
    font-size: 14px !important;
  }

.app-table.cashback-table.v-data-table--mobile ::v-deep tbody tr {
  border-bottom: 2px solid #000 !important;
  margin-bottom: 8px !important;
  padding-bottom: 4px !important;
  display: block !important;
}

.app-table.cashback-table.v-data-table--mobile ::v-deep .v-data-table__mobile-row {
  width: 100% !important;
  display: flex !important;
  justify-content: space-between !important;
}


  .app-table.cashback-table.v-data-table--mobile .v-data-table__mobile-row__cell {
    text-align: right !important;
    white-space: normal;
    word-break: break-word;
  }

  .v-data-table__mobile-row .v-btn {
    min-width: unset !important;
    padding: 0 6px !important;
    font-size: 10px !important;
    height: 22px !important;
  }
}
.popup-mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px 16px;
}

.popup-mobile-header-title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  display: flex;
  align-items: center;
}

.popup-mobile-close.v-btn {
  background-color: #f0f0f0 !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  box-shadow: none !important;
}

.popup-mobile-close.v-btn .v-icon {
  color: #555 !important;
}

.popup-mobile-dialog {
  border-radius: 12px;
}

.app-table.cashback-table.v-data-table--mobile ::v-deep .v-data-table__mobile-row {
  padding-left: 0 !important;
}
</style>